import { useMemo } from 'react';
import { useAuth } from 'react-oidc-context';
import { canDeprecate, canManageRelease, decodeUserInfo } from '../utils/authhelpers/authhelpers';

/**
 * Decoded id-token identity plus the role-derived permission flags.
 *
 * The groups come from the `custom:groups` claim; the permitted role names are
 * env-driven (`src/config/roles.js`). Memoised on the token so the decode does
 * not re-run on every render.
 */
export function useUserRoles() {
  const auth = useAuth();
  const idToken = auth?.user?.id_token;
  const refreshToken = auth?.user?.refresh_token;

  const userInfo = useMemo(
    () => (idToken ? decodeUserInfo(idToken, refreshToken) : null),
    [idToken, refreshToken]
  );

  const groups = userInfo?.groups;

  return useMemo(
    () => ({
      userInfo,
      groups: groups || [],
      allowDeprecate: canDeprecate(groups),
      allowManageRelease: canManageRelease(groups),
    }),
    [userInfo, groups]
  );
}
